import { getContext, setContext } from "svelte";

const key = Symbol("clientWidth");

export function getClientWidth(): number {
  return getContext<{ width: number }>(key).width;
}

export function setClientWidth(state: { width: number }): void {
  setContext(key, state);
}
